import { render, staticRenderFns } from "./List3.vue?vue&type=template&id=7f3b7f35"
import script from "./List3.vue?vue&type=script&lang=js"
export * from "./List3.vue?vue&type=script&lang=js"
import style0 from "./List3.vue?vue&type=style&index=0&id=7f3b7f35&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports